import React, {Component} from 'react';
import { connect } from 'react-redux';
// Components
import ReplaySection from 'components/presentational/ReplaySection';
import Footer from 'components/presentational/Footer';
import SubmitDocumentationSVG from 'components/svg/SubmitDocumentationSVG.js';
import GTMPush from 'components/GTMPush'

// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';
// Files
import './submit-documentation.scss';


const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedSubmitDocumentation extends Component {
    constructor() {
        super();
        this.audio = React.createRef();

        // Bindigs
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('SubmitDocumentation');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection()
    }
  
    render() {
        return (
            <div className="submit-documentation text-center" >
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="04" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                  
                <div className="container">
                    <h1 className="submit-documentation__heading heading-1">Step 3: Submit your documentation</h1>

                    <div className="submit-documentation__content">
                        <p>Once you’ve completed and signed the claim form, and you have the death certificate and any other necessary documents, you can submit your claim. You choose how you’d like to submit — via online portal at <a href="https://metlife.com/lifeclaims" className="link" target="_blank" rel="noopener noreferrer">metlife.com/lifeclaims</a> or mail it to:</p>

                        <p><strong>MetLife Group Life Claims <br/>
                            P.O. Box 6100 <br/>
                            Scranton, PA 18505-6100</strong>
                        </p>
                    </div>
                    
                    <SubmitDocumentationSVG className="submit-documentation__image" />

                    <ReplaySection handleClick={this.handleReplayClick}/>
                </div>

                <Footer pageIndex={4}/>
            </div>
        )
    }
}

const SubmitDocumentation = connect(mapStateToProps, mapDispatchToProps)(ConnectedSubmitDocumentation);

export default SubmitDocumentation
